import { useTranslation } from 'react-i18next'
import { PosProfilesList } from './pos-profiles-list'
import { PageHeader } from '../../../components/page-header'
import { Button, Grid, Menu, MenuItem } from '@mui/material'
import { FilterProvider } from '../../../components/data-grid/context'
import { usePageTitle } from '../../../hooks/title'
import { useNavigate } from 'react-router-dom'
import { useAbsolutePath } from '../../../hooks/absolute-path'
import { RootRoute } from '../..'
import { MouseEventHandler, useState } from 'react'
import { MoreButton } from '../../../components/more-button'
import { ExportPosProfilesDialog } from './export-pos-profiles-dialog'
import { ImportPosProfilesDialog } from './import-pos-profiles-dialog'

export const SettingsPosProfilesPage = () => {
  const { t } = useTranslation('pos_profiles')
  usePageTitle(t('pos_profiles:page_title'))
  const navigate = useNavigate()
  const generatePath = useAbsolutePath()
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const [openExportDialog, setOpenExportDialog] = useState(false)
  const [openImportDialog, setOpenImportDialog] = useState(false)

  const isOpen = !!anchorEl

  const handleClick: MouseEventHandler<HTMLButtonElement> = (event) => {
    setAnchorEl(isOpen ? null : event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <FilterProvider>
      <Grid container>
        <Grid size="grow">
          <PageHeader
            title={t('pos_profiles:page_title')}
            isSticky
            isFlexible={true}
            rightColumn={
              <>
                <MoreButton onClick={handleClick} />
                <Button
                  data-testid="add-pos-profile-button"
                  onClick={() =>
                    navigate(generatePath(RootRoute.SettingsPosProfileNew))
                  }
                >
                  {t('pos_profiles:add_pos_profile')}
                </Button>

                <Menu
                  anchorEl={anchorEl}
                  open={isOpen}
                  onClose={handleClose}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                  <MenuItem
                    data-testid="export-pos-profiles-button"
                    onClick={() => {
                      setOpenImportDialog(true)
                      setAnchorEl(null)
                    }}
                  >
                    {t('pos_profiles:export.import')}
                  </MenuItem>
                  <MenuItem
                    data-testid="export-pos-profiles-button"
                    onClick={() => {
                      setOpenExportDialog(true)
                      setAnchorEl(null)
                    }}
                  >
                    {t('pos_profiles:export.export')}
                  </MenuItem>
                </Menu>
                <ExportPosProfilesDialog
                  onClose={() => {
                    setOpenExportDialog(false)
                  }}
                  open={openExportDialog}
                />
                <ImportPosProfilesDialog
                  onClose={() => {
                    setOpenImportDialog(false)
                  }}
                  open={openImportDialog}
                />
              </>
            }
          />

          <PosProfilesList />
        </Grid>
      </Grid>
    </FilterProvider>
  )
}
